export function ResultsSkeleton() {
  return (
    <div className="results-skeleton">
      <ResultSkeleton />
      <ResultSkeleton />
      <ResultSkeleton />
    </div>
  );
}

export function ResultSkeleton() {
  return (
    <div className="card">
      <div className="image loading"></div>
      <div className="middle-col">
        <div className="title loading"></div>
        <div className="subtitle loading"></div>
        <div className="locations loading"></div>
        <div className="accepting loading"></div>
      </div>
      <div className="divider loading"></div>
      <div className="right-col">
        <div className="phone loading"></div>
        <div className="btn loading"></div>
      </div>
    </div>
  );
}
